export const padNumber = (num: number, size: number)  => {
  let val = num.toString();
  while (val.length < size) val = "0" + val;
  return val;
}